import { Spinner } from '@fluentui/react-components';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import classNames from 'classnames';
import React from 'react';
import styles from '../CommonAppHostControlStyles.module.scss';
import { OfficeUserThemeSpinner, useOfficeUserThemeStyles } from '../styles';
export var AppHostLoadingControl = function (_a) {
    var label = _a.label;
    var officeThemeStyles = useOfficeUserThemeStyles();
    return (
    /** This fluent provider is here because the className/style props do not work. Seems like a fluent bug. */
    React.createElement(OfficeFluentProvider, { className: classNames(styles.container, styles.transparentBackground), theme: OfficeUserThemeSpinner },
        React.createElement(Spinner, { label: label, size: "small", labelPosition: "below", className: officeThemeStyles.foreground })));
};
//# sourceMappingURL=AppHostLoadingControl.js.map